/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartResetPasswordRequest
 */
export interface StartResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof StartResetPasswordRequest
     */
    email: string;
}

/**
 * Check if a given object implements the StartResetPasswordRequest interface.
 */
export function instanceOfStartResetPasswordRequest(value: object): value is StartResetPasswordRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function StartResetPasswordRequestFromJSON(json: any): StartResetPasswordRequest {
    return StartResetPasswordRequestFromJSONTyped(json, false);
}

export function StartResetPasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartResetPasswordRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function StartResetPasswordRequestToJSON(json: any): StartResetPasswordRequest {
    return StartResetPasswordRequestToJSONTyped(json, false);
}

export function StartResetPasswordRequestToJSONTyped(value?: StartResetPasswordRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

